module.exports = __webpack_public_path__ + "static/media/crosshairs.f74aff74.svg";